export default __webpack_public_path__ + "img/9e53c33fedde3f72e7830d356b85b66c.png";